export const TYPES = {
    MESSAGES: 'messages',
    NOTIFICATIONS: 'notifications',
    MESSAGES_MODERN: 'messages_modern',
    NOTIFICATIONS_MODERN: 'notifications_modern',
    BOTH: 'both',
} as const;

export type DrawerType = (typeof TYPES)[keyof typeof TYPES];

export const includesInboxDrawer = (drawerType: DrawerType) =>
    includes(drawerType, [TYPES.MESSAGES, TYPES.BOTH, TYPES.MESSAGES_MODERN]);

export const includesNotificationsDrawer = (drawerType: DrawerType) =>
    includes(drawerType, [TYPES.NOTIFICATIONS, TYPES.BOTH, TYPES.NOTIFICATIONS_MODERN]);

const includes = (drawerType: DrawerType, options: DrawerType[]) => !drawerType || options.includes(drawerType);

/**
 * Normalizes modern types to their base types for functional logic.
 * Modern types are only for button UI, all other logic should treat them as base types.
 */
export const normalizeDrawerType = (drawerType: DrawerType) => {
    if (drawerType === TYPES.MESSAGES_MODERN) {
        return TYPES.MESSAGES;
    }
    if (drawerType === TYPES.NOTIFICATIONS_MODERN) {
        return TYPES.NOTIFICATIONS;
    }
    return drawerType;
};

/**
 * Checks if drawerType is a messages type (including modern variant)
 */
export const isMessagesType = (drawerType: DrawerType) =>
    includesInboxDrawer(drawerType) && !includesNotificationsDrawer(drawerType);

/**
 * Checks if drawerType is a notifications type (including modern variant)
 */
export const isNotificationsType = (drawerType: DrawerType) =>
    includesNotificationsDrawer(drawerType) && !includesInboxDrawer(drawerType);
